import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@spoiler-alert/ui-library';

interface PlainItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

const useStyles = createUseStyles({
  item: {
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '24px',
    borderRadius: 6,
    marginLeft: 12,
    '&:hover': {
      backgroundColor: Theme.grey10,
      border: `1px solid ${Theme.borderColor}`,
    },
  },
  itemActive: {
    border: `1px solid ${Theme.borderColor}`,
    background: Theme.grey10,
  },
});

export function PlainItem({ label, isActive, onClick }: PlainItemProps) {
  const classes = useStyles();

  return (
    <div className={`${classes.item} ${isActive ? classes.itemActive : ''}`} onClick={onClick}>
      {label}
    </div>
  );
}
